import { useQuery } from '@tanstack/react-query';
import ProductCard from '@/components/ProductCard';
import { Product } from '@/services/productService';
import { fetchBestsellerIds, MIN_BESTSELLERS } from '@/services/bestsellerService';

export default function Bestsellers({ products }: { products: Product[] }) {
  const { data: ids = [] } = useQuery({
    queryKey: ['bestseller-ids'],
    queryFn: fetchBestsellerIds,
    staleTime: 60_000,
  });
  const byId = new Map(products.filter(product => product.isActive !== false).map(product => [product.id, product]));
  const selected = ids.map(id => byId.get(id)).filter((product): product is Product => Boolean(product));

  if (selected.length < MIN_BESTSELLERS) return null;

  return (
    <section aria-labelledby="bestsellers-heading" className="border-y border-amber-100 bg-[#fffaf2] py-8 md:py-12">
      <div className="w-full px-2 md:container md:mx-auto md:px-4">
        <div className="mb-5">
          <p className="mb-1 text-xs font-bold uppercase tracking-[0.2em] text-amber-800">Customer favourites</p>
          <h2 id="bestsellers-heading" className="text-2xl font-bold text-foreground md:text-3xl">Bestsellers</h2>
        </div>
        <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-6 lg:grid-cols-4" aria-label="Bestselling products">
          {selected.map(product => (
            <ProductCard key={product.id} {...product} />
          ))}
        </div>
      </div>
    </section>
  );
}
